import { makeStyles } from 'tss-react/mui';

/** Mobile chrome above campaign step content (app bar + in-flow stepper reserve). */
const MOBILE_CAMPAIGN_CHROME_PX = 112;

export default makeStyles()((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    flex: 1,
    minHeight: 0,
    alignSelf: 'stretch',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
  },
  /* In-flow wrapper: reserves height so container starts below (like Appbar wrapper). */
  stepperWrapper: {
    position: 'relative',
    height: '56px',
    width: '100%',
    flexShrink: 0,
    zIndex: 2,
  },
  /* Fixed strip painted on top of the reserved space; sticks on scroll. */
  stepperFullWidth: {
    position: 'fixed',
    left: 0,
    right: 0,
    width: '100%',
  },
  stepperPaper: {
    width: '100%',
    borderRadius: 0,
    marginBottom: 0,
    border: 'none',
    borderBottom: 'none',
    boxShadow: 'none',
    display: 'flex',
    justifyContent: 'center',
  },
  titleLink: {
    color:
      theme.palette.mode === 'dark'
        ? theme.palette.text.primary
        : theme.palette.primary.main,
    '&:hover': {
      color: theme.palette.brands?.elevator_red ?? theme.palette.secondary.main,
      textDecoration: 'none',
    },
  },
  mobileStepper: {
    minWidth: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.text.primary,
    padding: theme.spacing(2, 0),
  },
  steps: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    textAlign: 'center',
    boxShadow: 'none',
    color: theme.palette.text.primary,
    padding: theme.spacing(2),
    maxWidth: 800,
    margin: '0 auto',
    width: '100%',
    '& .MuiStepConnector-line': {
      borderColor: theme.palette.divider,
      borderTopWidth: 1,
      borderTopStyle: 'solid',
    },
    '& .MuiStepConnector-lineHorizontal': {
      borderColor: theme.palette.divider,
      borderTopWidth: 1,
      borderTopStyle: 'solid',
    },
  },
  step: {
    '&:first-of-type': {
      paddingLeft: theme.spacing(20),
    },
    '&:last-child': {
      paddingRight: theme.spacing(20),
    },
  },
  activeIcon: {
    '&&': {
      color: '#C20000',
      '& .MuiStepIcon-text': {
        fill: '#ffffff',
      },
    },
  },
  completedIcon: {
    '&&': {
      color: theme.palette.text.primary,
    },
  },
  stepContentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      flex: 1,
      minHeight: `calc(100dvh - ${MOBILE_CAMPAIGN_CHROME_PX}px)`,
    },
  },
}));
